import { render } from "./CoinbaseCreditPaymentModal.vue?vue&type=template&id=7994e8c6&scoped=true"
import script from "./CoinbaseCreditPaymentModal.vue?vue&type=script&lang=js"
export * from "./CoinbaseCreditPaymentModal.vue?vue&type=script&lang=js"

import "./CoinbaseCreditPaymentModal.vue?vue&type=style&index=0&id=7994e8c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/web-frontend-dev/web-frontend-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7994e8c6"]])

export default __exports__